var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.157,
    height: 47.157,
    viewBox: "0 0 47.157 47.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party",
    transform: "translate(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M271.5,113.787c-.368,1.424-.737,2.836-1.117,4.26a4.147,4.147,0,0,1-.467,1.191,1.816,1.816,0,0,1-2.492.626c-.381-.2-.749-.417-1.117-.638s-.7-.442-1.117-.712c-.037.6-.086,1.142-.11,1.694-.025.381-.012.773-.037,1.154a1.892,1.892,0,0,1-2.762,1.633c-1.08-.516-2.124-1.093-3.18-1.645-.172-.086-.344-.184-.589-.307,0,.786.025,1.522,0,2.247a1.375,1.375,0,0,1-2.1,1.191,1.333,1.333,0,0,1-.651-1.191c0-1.228-.012-2.455,0-3.683a1.878,1.878,0,0,1,2.8-1.682c1.117.577,2.21,1.191,3.315,1.78.135.074.27.135.454.221.049-.663.1-1.277.135-1.878.037-.43.061-.859.1-1.289a1.893,1.893,0,0,1,3-1.424c.577.405,1.142.823,1.719,1.228.16.111.332.209.54.331.282-1.1.552-2.161.81-3.2.037-.16.074-.332.123-.491a1.4,1.4,0,0,1,1.3-1.117,1.388,1.388,0,0,1,1.363.908c.025.049.061.1.086.16Z",
    transform: "translate(-224.443 -98.317)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M324.323,4.518c-.061.233-.111.467-.172.7a4.155,4.155,0,0,1-8.177-.921A4.178,4.178,0,0,1,319.326.1a2.767,2.767,0,0,0,.295-.1h1.019a1.5,1.5,0,0,0,.209.086,4.1,4.1,0,0,1,3.34,3.168c.049.172.086.344.135.516Z",
    transform: "translate(-277.266)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M-.088,322.533c.123-.221.246-.442.356-.675l2.615-5.967c.061-.147.147-.295.233-.491,2.775,1.277,5.512,2.541,8.349,3.843-.233.111-.381.184-.54.258-3.192,1.4-6.4,2.8-9.589,4.2a2.26,2.26,0,0,0-.233.135H-.1C-.088,323.392-.088,322.963-.088,322.533Z",
    transform: "translate(0 -276.677)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M79.4,109.323a2.887,2.887,0,0,1,1.829-2.554,2.948,2.948,0,0,1,3.266.5,4.077,4.077,0,0,1,.331.319q9.042,9.024,18.06,18.072a3.072,3.072,0,0,1-3.953,4.7c-.147-.123-.27-.246-.405-.381q-9.042-9.024-18.072-18.06A3.463,3.463,0,0,1,79.4,109.323Z",
    transform: "translate(-69.74 -93.411)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M52.869,256.126c-2.3,1.007-4.481,1.964-6.667,2.91a.51.51,0,0,1-.381,0c-3.487-1.6-6.973-3.2-10.522-4.837.81-1.854,1.621-3.7,2.455-5.6C42.777,251.1,47.774,253.585,52.869,256.126Z",
    transform: "translate(-31.054 -218.079)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M80.843,194.963q-8.048-4-16.243-8.091Q65.852,184,67.092,181.2,74,188.124,80.843,194.963Z",
    transform: "translate(-56.757 -158.954)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M212.344,12.529a3.372,3.372,0,0,1-.516.516c-.81.467-1.645.9-2.455,1.363a1.307,1.307,0,0,0-.467.467c-.454.786-.859,1.6-1.314,2.37-.123.2-.368.442-.552.442s-.43-.258-.552-.454c-.442-.737-.81-1.51-1.252-2.247a1.976,1.976,0,0,0-.663-.651c-.749-.442-1.535-.835-2.284-1.277a.819.819,0,0,1-.393-.54c-.012-.16.209-.393.381-.491.786-.454,1.584-.859,2.37-1.314a1.621,1.621,0,0,0,.552-.565c.442-.749.835-1.535,1.277-2.284.123-.2.368-.479.54-.467.209.012.454.27.589.479.454.761.847,1.559,1.3,2.333a1.413,1.413,0,0,0,.467.467c.81.467,1.645.9,2.455,1.363A2.606,2.606,0,0,1,212.344,12.529Z",
    transform: "translate(-177.196 -6.489)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M198.7,119.455a1.286,1.286,0,0,1,.847-1.117c1.35-.54,2.7-1.068,4.064-1.584a1.375,1.375,0,0,1,1.78.786,1.357,1.357,0,0,1-.749,1.756c-1.363.552-2.726,1.093-4.1,1.6A1.374,1.374,0,0,1,198.7,119.455Z",
    transform: "translate(-174.392 -102.34)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M116.487,15.586c-.025.086-.049.282-.111.467-.442,1.265-.9,2.541-1.35,3.806a1.386,1.386,0,1,1-2.6-.909c.454-1.314.921-2.627,1.4-3.929a1.367,1.367,0,0,1,1.571-.9A1.4,1.4,0,0,1,116.487,15.586Z",
    transform: "translate(-98.613 -12.369)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M288.563,91.5a1.375,1.375,0,1,1-1.363,1.387A1.389,1.389,0,0,1,288.563,91.5Z",
    transform: "translate(-252.027 -80.265)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M292.461,228.936a1.369,1.369,0,1,1,.037-2.738,1.365,1.365,0,0,1,1.35,1.4A1.345,1.345,0,0,1,292.461,228.936Z",
    transform: "translate(-255.447 -198.427)",
    fill: "#cf2856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M177.749,87.9a1.362,1.362,0,0,1-1.387,1.35A1.381,1.381,0,0,1,175,87.862a1.408,1.408,0,0,1,1.4-1.363A1.381,1.381,0,0,1,177.749,87.9Z",
    transform: "translate(-153.601 -75.879)",
    fill: "#cf2856"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.6bd437aa313521a5169f1e29fdd23ced.svg";
export { ForwardRef as ReactComponent };